enum LogoName {
  Hugo = 'Hugo',
}

export const filterLogoAssets: {[key in LogoName]: string} = {
  [LogoName.Hugo]: require('./x-hugo-logo.svg'),
};
